import { render, staticRenderFns } from "./MobileTest.vue?vue&type=template&id=d3fdd1a0&scoped=true&"
import script from "./MobileTest.vue?vue&type=script&lang=js&"
export * from "./MobileTest.vue?vue&type=script&lang=js&"
import style0 from "./MobileTest.vue?vue&type=style&index=0&id=d3fdd1a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3fdd1a0",
  null
  
)

export default component.exports